<script>
import TablePage from '../../../../../../../components/table_page';
import configs from './config';

export default {
  extends: TablePage,
  props: {
    data: Array,
    value: [],
    selectKeys: Array,
  },
  data() {
    return {
      configs,
      selection: [],
    };
  },
  watch: {
  },
  created() {
    this.getConfigList('product_table', true, true);
  },
  methods: {
    afterCheckboxChange() {
      this.$emit('onSelect', this.selectRow);
    },
    afterCheckAllChange(val) {
      this.$emit('onSelect', val.selection);
    },
    afterGetList() {
      this.selection = this.selectKeys || [];
    },
  },

};
</script>

<style>

</style>
